export enum ErrorTypes {
  CategoryMissing = 'CategoryMissing',
  LibraryBookMissing = 'LibraryBookMissing',
  ChallengeMissing = 'ChallengeMissing',
  ContentNotFound = 'ContentNotFound',
  Adam = 'Adam',
}

export class Eva2Error extends Error {
  type: string;
  params: any = null;
  constructor(type: ErrorTypes, params?: any, message?: string) {
    super(message);
    this.type = type;
    this.params = params;
    // 👇️ because we are extending a built-in class
    Object.setPrototypeOf(this, Eva2Error.prototype);
  }

  getErrorMessage() {
    return this.message;
  }
}
